import { useFormikContext } from "formik";
import { ArrowLeftCircle, ArrowRightCircle } from "react-bootstrap-icons";
import { Button } from "../UiComponents/button";

// Props for the FormButtons component
declare interface FormNavButtonsProps {
  hideBack?: boolean;
  hideNext?: boolean;
  submitting?: boolean;
  submitText?: string;
}

// Component for rendering form navigation buttons
export function FormNavButtons({ hideBack, hideNext, submitting, submitText }: FormNavButtonsProps): JSX.Element {
  const { setFieldValue } = useFormikContext();

  // Determine the text for the submit button based on the form state
  const submitBtnText = submitting !== undefined ? submitText ?? 'Submit' : 'Next';
  
  return (
    <div className="inline-flex flex-row w-full mt-4">
      {/* Render Back button if hideBack is not true */}
      {!hideBack &&
        <Button
          type="submit"
          abbr={submitting ? "Button is disabled" : "Go to previous slide"} // when button is disabled, no abbr text
          className="px-7 sm:px-11 md:px-16"
          disabled={submitting} onClick={() => {
            setFieldValue('submitAction', 'back')
          }}
        >
          <div className="inline-flex justify-center items-center">
            <ArrowLeftCircle className="w-5 h-5" />
            <span className="ml-2">Back</span>
          </div>
        </Button>
      }
      {/* Render Next button if hideNext is not true */}
      {!hideNext && <div className="ml-auto">
        <Button
          type="submit"
          abbr={submitting !== undefined ? (submitText ?? "Submit the form") : "Go to next slide"}
          className="px-7 sm:px-11 md:px-16"
          disabled={submitting}
          onClick={() => setFieldValue('submitAction', 'next')}
        >
          <div className="inline-flex justify-center items-center ">
            <span className="mr-2">{submitBtnText}</span>
            <ArrowRightCircle className="w-5 h-5" />
          </div>
        </Button>
      </div>}
    </div>
  );
}
